import React from "react";
import numeral from 'numeral';
import querySearch from 'stringquery';
import ReactTooltip from 'react-tooltip';
import Cookies from "js-cookie";

const formatNumber = (number) => {
    let result = number;
    if (number) {
        result = numeral(number).format('0,0');
    }
    return result;
}

const parseQueryParams = (props) => {
    if (props && props.location) {
        const parsed = querySearch(props.location.search);
        return parsed;
    } else {
        return null;
    }
}

const renderStatusIcon = (status) => {
  let icon = '';
  if (status === 'failed') {
    icon = 'highlight_off';
  } else if (status === 'running') {
    icon = 'timelapse';
  } else if (status === 'success') {
    icon = 'check_circle';
  } else if (status === 'not_started' || status === 'setting_up') {
    icon = 'not_started'
  } else if (status === 'skipped') {
    icon = 'unpublished'
  } else {
    icon = status
  }
  return (
    <span className={`material-icons icon__status__container`}>
      <i className={`material-icons icon__status__${status}`}>{icon}</i>
    </span>
  );
};

const renderStatusLabel = (status) => {
  let label = '';
  if (status === 'running') {
    label = 'Running';
  } else if (status === 'success') {
    label = 'Success';
  } else if (status === 'failed') {
    label = 'Failed';
  } else if (status === 'not_started') {
    label = 'Not started'
  } else if (status === 'skipped') {
    label = 'Skipped'
  } else if (status === 'setting_up') {
    label = 'Setting up'
  } else {
    label = status
  }
  return (
    <span>{label}</span>
  );
};

const renderTooltip = (data) => {
  let randomId = String(Math.random());
  return (
    <>
      <span className={`material-icons data-pipeline__tooltip`}>
        <i className={`material-icons data-pipeline__tooltip_icon`} data-tip={data} data-for={randomId}>help_outline</i>
      </span>
      <ReactTooltip id={randomId} effect='solid' type='light' place='right' html />
    </>
  );
};

const openLinkInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
};

const setCookies = (key, value) => {
  Cookies.set(key, value, {
    secure: process.env.REACT_APP_DATADEX_ENV === 'production',
    expires: 1,
    path: '/',
    sameSite: process.env.REACT_APP_DATADEX_ENV === 'production' ? 'None' : 'lax',
  });
};

export default {
    formatNumber,
    parseQueryParams,
    renderStatusIcon,
    renderStatusLabel,
    renderTooltip,
    openLinkInNewTab,
    setCookies
}